import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BRAND } from '../../data/brand/brand.data';

// Shared "centered status" screen used by the 404 and maintenance pages: the
// brand illustration with a soft accent glow, a title + subtitle, the outline
// action button, and (404 only) a row of helpful links. The two pages differ
// only in illustration, copy, accent and the action they fire.
@Component( {
  selector: 'app-status-state',
  templateUrl: './status-state.component.html',
  styleUrls: [ './status-state.component.scss' ],
} )
export class StatusStateComponent {

  // Brand illustration shown at the top (e.g. BRAND.logo.error / .maintenance).
  @Input() logo!: string;
  // Message lines: [ { text: title }, { text: subtitle } ].
  @Input() heroContents: { text: string; level?: number }[] = [];
  // Status type (error / warning / …) — either the INFORMATION_TYPES object or
  // its cssClass string. Drives the accent (glow + button border).
  @Input() informationType: any;
  @Input() buttonText = 'HOME';
  // Optional id placed on the layout root so external code can scroll to it
  // (the maintenance page is scrolled into view via getElementById).
  @Input() headId?: string;
  // Optional helpful links shown under the button (404 uses these).
  @Input() links: { label: string; url: string }[] = [];

  @Output() action = new EventEmitter<void>();

  BRAND = BRAND;

  get title(): string {
    return this.heroContents?.[ 0 ]?.text ?? '';
  }

  // Every line after the title is rendered as its own subtitle line.
  get subtitleLines(): string[] {
    return ( this.heroContents || [] ).slice( 1 ).map( c => c.text ).filter( Boolean );
  }

  // The accent recolours the illustration glow and the button border + hover:
  // error red on 404, warning yellow on maintenance.
  get accentColor(): string {
    const type = this.informationType?.cssClass ?? this.informationType;
    if ( type === 'error' ) {
      return 'var(--error)';
    }
    if ( type === 'warning' ) {
      return 'var(--warning)';
    }
    return 'var(--theme-color)';
  }
}
